module.exports = __webpack_public_path__ + "img/pabellon_comercial.50b89151.jpg";